import React from "react";
import "./style.css";
import moment from "moment";
import numeral from "numeral";
import { FormattedMessage } from "react-intl";

const DepreciationDrawerLogsDetails = ({filteredLogs}) => {
  return (
    <div 
      style={{
        marginTop: "40px",
        display: "flex",
        flexDirection: "column"
      }}>
      <span style={{marginLeft: "8px", fontSize: "16px", fontWeight: "bold", color: "#152935"}}>
        <FormattedMessage id="preCog.assetsTab.drawer.logs.depreciationTitle" />
      </span>
      <span className="precog-assets-drawer-logs-sub-title">
        <FormattedMessage id="preCog.assetsTab.drawer.logs.docOpsInfoTitle" />
      </span>
      <div style={{display: "flex", flexWrap: "wrap"}}>
        <div>
          <span className="precog-assets-drawer-logs-depreciation-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.depreciationDate" />
          </span>
          <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.date === null ? "XXXXXXX" : moment(filteredLogs[0]?.date).format("DD/MM/YYYY")}</p>
        </div>
        <div>
          <span className="precog-assets-drawer-logs-depreciation-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.depreciationPercentage" />
          </span>
          <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.rate === null ? "0 %": `${filteredLogs[0]?.rate} %`}</p>
        </div>
        <div>
          <span className="precog-assets-drawer-logs-depreciation-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.totalToBeDepreciated" />
          </span>
          <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.amount === null ? "XXXXXXX" : `${numeral(filteredLogs[0]?.amount).format("0,0.00")} €`}</p>
        </div>
        <div>
          <span className="precog-assets-drawer-logs-depreciation-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.depreciationQuote" />
          </span>
          <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.logAmount === null ? "XXXXXXX" : `${numeral(filteredLogs[0]?.logAmount).format("0,0.00")} €`}</p>
        </div>
        <div>
          <span className="precog-assets-drawer-logs-depreciation-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.residualDepreciation" />
          </span>
          <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.carryingValue === null ? "XXXXXXX" : `${numeral(filteredLogs[0]?.carryingValue).format("0,0.00")} €`}</p>
        </div>
        <div>
          <span className="precog-assets-drawer-logs-depreciation-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.accumulatedDepreciation" />
          </span>
          <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.accumulatedDepreciation === null ? "XXXXXXX" : `${numeral(filteredLogs[0]?.accumulatedDepreciation).format("0,0.00")} €`}</p>
        </div>
        <div>
          <span className="precog-assets-drawer-logs-depreciation-info-title">
            <FormattedMessage id="preCog.assetsTab.drawer.logs.suspensionPercentage" />
          </span>
          <p className="precog-assets-drawer-logs-info">{filteredLogs[0]?.suspesionRate === null ? "0 %" : `${filteredLogs[0]?.suspesionRate} %`}</p>
        </div>
      </div>
    </div>
  );
};

export default DepreciationDrawerLogsDetails;